import { api } from "../../service/api";
import { AuthLoginApi, AuthRegisterApi } from "../../service/controller/AuthController";
import { GetClientApi } from "../../service/controller/ClientsController";
import { getCookie, setCookie, deleteCookie } from "../../util/Cookie";
import { UserActionType } from "./action-type";


var user_data = getCookie("user_data");
const userState = (user_data && user_data !== undefined && user_data != null) ? JSON.parse(user_data ?? "{}") : null

const initialState = {
    user: userState
}

const useUser = (state = initialState, action) => {
    const request = action.payload;

    if (action.type === UserActionType.LOGIN) {
        AuthLoginApi({
            login: request.email,
            senha: request.password
        }, response => {
            GetClientApi(response.usuario.clienteId, (client) => {
                setCookie("client_data", JSON.stringify(client), 1);
                setCookie("user_data", JSON.stringify(response.usuario), 1);
                setCookie("access_token", response.token, 1);
                action.callBack(response.usuario);
            }, response.token)
            return { ...state, user: response }
        });
    }

    if (action.type === UserActionType.CREATE) {
        AuthRegisterApi({
            login: request.email
            , senha: request.password
            , confirmacaoSenha: request.password
            , cpf: request.cpf.replaceAll(".", "").replaceAll("-", "").replaceAll(" ", "")
            , nomeCompleto: request.fullName
            , dataNascimento: request.dateOfBirth
            , email: request.email
            , telefone: request.phone.replaceAll("(", "").replaceAll(")", "").replaceAll("-", "").replaceAll(" ", "")
            , tipoUsuario: "Cliente"
            , matricula: request.nb
            , cidade: request.city
            , uf: request.uf
        }, (isRequiredToken, solicitationNumber, token) => {
            if (isRequiredToken) {
                setCookie("access_token", token, 1);
                action.callBack(isRequiredToken, solicitationNumber);
                return { ...state }
            }
            action.callBack(false, '');
            return { ...state }
        });
    }

    if (action.type === UserActionType.LOGOUT) {
        deleteCookie("access_token");
        deleteCookie("user_data");
        return { ...state, user: null }
    }

    if (action.type === UserActionType.FORGOT_PASSWORD) {
        api.post('/api/Auth/recuperar-senha', action.payload, res => {
            action.callBack(res.data);
        })
    }

    if (action.type === UserActionType.TYPE_BENEFIT) {
        api.get('/api/BMGDadosMestres/tipos-beneficio', res => {
            action.callBack(res.data);
        })
    }

    return state;
}

export default useUser;